import { apiErrorHandler } from '../errorHandler'

export async function promoteOwner(userId: number): Promise<void> {
  const res = await fetch(`${window.location.origin}/api/user/${userId}/promoteOwner`, {
    method: 'POST',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
}

export async function demoteOwner(userId: number): Promise<void> {
  const res = await fetch(`${window.location.origin}/api/user/${userId}/demoteOwner`, {
    method: 'POST',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
}
